import axios from 'axios'
import CryptoJS from 'crypto-js'

type SignatureCtx = { ip: string; timestamp: number }

let cached: { value: SignatureCtx; at: number } | null = null

async function getSignatureCtx(): Promise<SignatureCtx> {
  const now = Date.now()
  if (cached && now - cached.at < 45_000) return cached.value

  const { data } = await axios.get<SignatureCtx>(
    '/api/auth/member/signature-ip',
  )

  cached = { value: data, at: now }
  return data
}

export async function withZBSignature<T extends { email?: string }>(
  payload: T,
): Promise<T> {
  const email = (payload.email ?? '').trim().toLowerCase()
  if (!email) return payload

  const secretKey = process.env.REACT_APP_ZB_SIGNATURE_KEY
  if (!secretKey) return payload

  const { ip, timestamp } = await getSignatureCtx()

  const canonical = `${email}|${ip}|${timestamp}`
  const signature = CryptoJS.HmacSHA256(canonical, secretKey).toString() // hex як у Postman

  return {
    ...(payload as any),
    signature,
    sig_ip: ip,
    sig_timestamp: timestamp,
  }
}
